/**
 * Minimal table-row wrapper. Returns children as a fragment so `<td>` stay
 * direct children of the `<tr>` owned by {@link DataTable}.
 */

import * as React from 'react';

/** Props for {@link TableRow}. */
interface TableRowProps {
  children: React.ReactNode;
  /** Unused; kept so {@link TableRow} matches the {@link TableCard} prop surface. */
  onClick?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTableRowElement>) => void;
  className?: string;
  ariaLabel?: string;
}

/** Table row for a data-table record. */
export const TableRow: React.FC<TableRowProps> = ({
  children,
  onClick,
  onKeyDown,
  className,
  ariaLabel,
}) => {
  return <>{children}</>;
};
